import React, { useState } from "react";
import DayForm from "./DayForm";
import { useParams } from "react-router-dom";
import clinicService from "../../../../../services/clinic.service";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

function EachDay({ day, hof, updateHours }) {
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const { clinicId } = useParams();

    const handleEdit = () => {
        setIsEditing(!isEditing);
    };

    const handleDelete = (hourid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `<i class="bi bi-check"></i> Yes, delete it!`,
            cancelButtonText: `<i class="bi bi-x"></i> Cancel`,
            reverseButtons: true,
            customClass: {
                title: 'card-title',
                confirmButton: 'btn btn-danger me-2 btn-sm',
                cancelButton: 'btn btn-secondary me-2 btn-sm'
            },
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                setIsDeleting(true);
                const setHr = [hourid];

                clinicService.deleteHours(clinicId, setHr)
                    .then(res => {
                        setIsDeleting(false);
                        // Filter out the deleted day from the hours array
                        const updatedHours = hof.filter(h => h.id !== hourid);
                        updateHours(updatedHours);

                        // Show success alert
                        Swal.fire({
                            title: 'Deleted!',
                            text: 'Hours have been deleted successfully.',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK',
                            customClass: {
                                confirmButton: 'btn btn-success'
                            },
                            buttonsStyling: false
                        });

                        toast.success("Hours deleted successfully", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    })
                    .catch(err => {
                        setIsDeleting(false);

                        // Show error alert
                        Swal.fire({
                            title: 'Error!',
                            text: 'Failed to delete hours. Please try again.',
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK',
                            customClass: {
                                confirmButton: 'btn btn-danger'
                            },
                            buttonsStyling: false
                        });

                        toast.error("Error deleting hours", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    });
            }
        });
    };

    return (
        <div className={`day-item p-3 mb-3 rounded ${isEditing ? 'bg-light border' : 'border'}`}>
            {isEditing ? (
                <DayForm
                    dayData={day}
                    hof={hof}
                    handleEdit={handleEdit}
                    updateHours={updateHours}
                />
            ) : (
                <div className="row align-items-center">
                    <div className="col-lg-2 col-md-2">
                        <div className="fw-medium text-center text-md-start">
                            {day.day}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3">
                        {day.status ? (
                            <div className="d-flex align-items-center">
                                <span className="badge bg-light text-dark fs-7">
                                    <i className="bi bi-clock me-1"></i>
                                    {day.start} - {day.end}
                                </span>
                            </div>
                        ) : (
                            <span className="text-muted">Closed</span>
                        )}
                    </div>
                    <div className="col-lg-2 col-md-2">
                        {day.status ? (
                            <span className="badge bg-success bg-opacity-10 text-success">
                                <i className="bi bi-check-circle me-1"></i> Open
                            </span>
                        ) : (
                            <span className="badge bg-danger bg-opacity-10 text-danger">
                                <i className="bi bi-x-circle me-1"></i> Closed
                            </span>
                        )}
                    </div>
                    <div className="col-lg-3 col-md-3">
                        <div className="text-muted small">
                            {day.note || <span className="fst-italic">No notes</span>}
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2 text-end">
                        <div className="" role="group">
                            <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={handleEdit}
                                title="Edit hours"
                            >
                                <i className="bi bi-pencil"></i> Edit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default EachDay;